import Config from '@Config';
import axios from 'axios';

const instance = axios.create({
  baseURL: Config.emailBaseUrl,
  headers: { 'Content-Type': 'application/json' },
});

export default instance;
